var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.364 5.63593C17.9734 5.24541 17.3403 5.24541 16.9497 5.63593L12 10.5857L7.05025 5.63593C6.65973 5.24541 6.02656 5.24541 5.63604 5.63593C5.24552 6.02646 5.24552 6.65962 5.63604 7.05015L10.5858 11.9999L5.63604 16.9496C5.24552 17.3402 5.24551 17.9733 5.63604 18.3639C6.02656 18.7544 6.65973 18.7544 7.05025 18.3639L12 13.4141L16.9497 18.3639C17.3403 18.7544 17.9734 18.7544 18.364 18.3639C18.7545 17.9733 18.7545 17.3402 18.364 16.9496L13.4142 11.9999L18.364 7.05015C18.7545 6.65962 18.7545 6.02646 18.364 5.63593Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic-delete.28245b7b00d379a55b1c2edcaec95445.svg";
export { ForwardRef as ReactComponent };